// @ts-check

/** @typedef {import ('./constants').SecureScoreProfileType} SecureScoreProfileType */

/**
 * Function to create secure score profiles
 * @returns {Record<SecureScoreProfileType, object>}
 * WARNING: To deprecate the Secure Score Profile check, set the value to null.
 */
export const secureScoreProfiles = () => ({
  mdo_mailboxintelligenceprotection: {},
  mdo_mailboxintelligenceprotectionaction: {},
  mdo_enabledomainstoprotect: {},
  mdo_phishthresholdlevel: {},
  mdo_targetedusersprotection: {},
  mdo_enablemailboxintelligence: {},
  mdo_targeteddomainprotectionaction: {},
  mdo_targeteduserprotectionaction: {},
  mdo_similardomainssafetytips: {},
  mdo_similaruserssafetytips: {},
  mdo_unusualcharacterssafetytips: {},
  mdo_zapphish: {},
  mdo_antiphishingpolicies: {},
  mdo_safelinksforemail: {},
  mdo_safeattachments: {},
  mdo_safeattachmentpolicy: {},
  mdo_zapmalware: {},
  mdo_commonattachmentsfilter: {},
  mdo_atpprotection: {},
  mdo_safedocuments: {},
  mdo_blockmailforward: {},
  mdo_highconfidencespamaction: {},
  mdo_phisspamacation: {},
  mdo_highconfidencephishaction: {},
  mdo_spamaction: {},
  mdo_spam_notifications_only_for_admins: {},
  mdo_bulkspamaction: {},
  mdo_safelinksforOfficeApps: {},
  mdo_allowedsenderscombined: {},
  mdo_quarantineretentionperiod: {},
  mdo_bulkthreshold: {},
  mdo_autoforwardingmode: {},
  mdo_thresholdreachedaction: {},
  mdo_zapspam: {},
  mdo_recipientexternallimitperhour: {},
  mdo_recipientinternallimitperhour: {},
  mdo_recipientlimitperday: {},
  mdo_connectionfilter: {},
})
